import {useState} from 'react';

const useSignUpForm = (callback) => {
    const [inputs, setInputs] = useState({});
    const handleSubmit = (event) => {
      if (event) {
        event.preventDefault();
      }
      callback();
    }
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));
    }
    const handleStartChange = (moment) => {
      console.log("useSignUpForm dateTime", "starts", moment ? moment.format() : "null");
      setInputs(inputs => ({...inputs, "starts": moment}));
    }
    const handleEndChange = (moment) => {
      setInputs(inputs => ({...inputs, "ends": moment}));
    }
    return {
      handleSubmit,
      handleInputChange,
      handleStartChange,
      handleEndChange,
      inputs
    };
  }
export default useSignUpForm;